import React from 'react'

export default function IFacebook( props ) {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" 
      xmlns="http://www.w3.org/2000/svg" {...props}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M0 28.1563C0 42.077 10.1103 53.6527 23.3333 56V35.777H16.3333V28H23.3333V21.777C23.3333 14.777 27.8437 10.8897 34.223 10.8897C36.2437 10.8897 38.423 11.2 40.4437 11.5103V18.6667H36.8667C33.4437 18.6667 32.6667 20.377 32.6667 22.5563V28H40.1333L38.8897 35.777H32.6667V56C45.8897 53.6527 56 42.0793 56 28.1563C56 12.67 43.4 0 28 0C12.6 0 0 12.67 0 28.1563Z" fill="white"/>
    </svg>
  )
}